import React, { useRef, useState, useEffect } from "react";

import { connect } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import SimpleReactValidator from "simple-react-validator";
import { Helmet } from "react-helmet";

import { postAllSubscribe } from "../../actions";

// import "./footer.css";
import classes from "./footer.module.scss";
import FooterLinks from "./footer-links";
import FooterSocial from "./footer-social";
import FooterBottom from "./footer-bottom";

const Footer = (props) => {
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const _reCaptchaRef = React.createRef();
  const validator = useRef(new SimpleReactValidator({
    autoForceUpdate: this, messages: {
      required: "Please enter your email address.",
      email: "Please enter a valid email address.",
    },
  }));
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const handleChange = (event) => {
    event.persist();
    setEmail(event.target.value);
  };

  const onRecaptcha = (e) => {
    e.preventDefault();

    if (validator.current.allValid()) {
      setLoader(true);
      _reCaptchaRef.current.executeAsync();
    } else {
      validator.current.showMessages();
      forceUpdate();
    }
  };

  const handleSubmit = (code) => {
    if (code) {
      var subscriptionEmail = { email: email };
      props.postAllSubscribe(subscriptionEmail);
      _reCaptchaRef.current.reset();
    }
  };

  useEffect(() => {
    setLoader(false);
    setEmail("");
    validator.current.hideMessages();
    forceUpdate();
  }, [props.subscribe_data]);

  const handleFooterAccordion = (index) => {
    if (index != 0) {
      var elems0 = document.querySelector(".inner0");
      elems0.classList.remove("d-block");
      elems0.classList.add("d-none");
    }
    if (index != 1) {
      var elems1 = document.querySelector(".inner1");
      elems1.classList.remove("d-block");
      elems1.classList.add("d-none");
    }
    if (index != 2) {
      var elems2 = document.querySelector(".inner2");
      elems2.classList.remove("d-block");
      elems2.classList.add("d-none");
    }

    var elems = document.querySelector(".inner" + index);
    if (elems.classList.contains("d-none")) {
      elems.classList.remove("d-none");
      elems.classList.add("d-block");
    } else {
      elems.classList.remove("d-block");
      elems.classList.add("d-none");
    }
  };

  const placeholder = "Your email";

  return (
    <footer className={classes.footer}>
      <Helmet>
        <meta property="og:url" content={window.location.href} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <div className="custom-container">
        <div className={classes.footer_top}>
          <div className={classes.title_wrap}>
            <h6 className={classes.footer_title}>Keep in touch</h6>
            <span className={classes.footer_desc}>Updates and exclusives.</span>
          </div>

          <div className={classes.form_wrap}>
            <form className={classes.newsletter_form} onSubmit={onRecaptcha}>
              <div className={classes.newsletter}>
                <input
                  id="newsletter"
                  type="text"
                  name="email"
                  value={email}
                  placeholder={`${placeholder} *`}
                  maxLength="128"
                  role="combobox"
                  aria-haspopup="false"
                  aria-autocomplete="both"
                  autoComplete="off"
                  aria-expanded="false"
                  onChange={handleChange}
                  className={`${classes.newsletter_input} required-placeholder`}
                // onBlur={() => validator.current.showMessageFor('email')}
                />
                <button
                  className={classes.newsletter_submit}
                  title="Subscribe"
                  type="submit"
                  aria-label="Subscribe"
                // onClick={() => onRecaptcha()}
                >
                  <span>Subscribe</span>
                </button>

                {/* {loader && (
                  <div data-uk-spinner className="uk-padding-small"></div>
                )} */}
              </div>
              {validator && (
                <div className={classes.error_message}>
                  {" "}
                  {validator.current.message("email", email, "required|email")}
                </div>
              )}

              <ReCAPTCHA
                ref={_reCaptchaRef}
                size="invisible"
                sitekey={global.reCaptcha}
                onChange={handleSubmit}
              />
            </form>
          </div>
        </div>
        <FooterLinks />
        <FooterSocial />
        <FooterBottom />
      </div>
    </footer>
  );
};

const mapStateToProps = (state) => ({
  subscribe_data: state.data.subscribe_data,
});

export default connect(mapStateToProps, { postAllSubscribe })(Footer);
